import { render } from "./StationOqc.vue?vue&type=template&id=38421b53&scoped=true"
import script from "./StationOqc.vue?vue&type=script&lang=js"
export * from "./StationOqc.vue?vue&type=script&lang=js"

import "./StationOqc.vue?vue&type=style&index=0&id=38421b53&scoped=true&lang=less"

import exportComponent from "E:\\work\\苏州卓盛\\捷博独立发货\\jb-dji-wms-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38421b53"]])

export default __exports__